'use strict';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {isLink} from '../../_libs/angular-domain/DomainUtilities';
import {getLink} from '../../core-utilities/domain/ReduxUtils';


export const CLASS_NAME = 'CommentDomain';
export const COLLECTION = 'comments';

export function CommentDomainProvider() {
  return {
    $get: ['$injector', 'FirebaseUtil', '$firebaseObject', 'AbstractDomainClass', 'OrgIdMixin',
      function ($injector, FirebaseUtil, $firebaseObject, AbstractDomainClass, OrgIdMixin) {
        //console.log('Calling CommentDomain');
        function CommentDomain(data) {
          AbstractDomainClass.call(this, CommentDomain, data);
        }

        AbstractDomainClass.__inheritFrom(CommentDomain, CLASS_NAME, COLLECTION, {autoBind: false});
        OrgIdMixin(CommentDomain);

        CommentDomain.$constraints.addConstraints({
          org: {type: 'string'},
          message: {type: 'string', minSize: 1, maxSize: 2048},
          conversation: {type: 'DomainLink', domainClass: 'ConversationDomain', nullable: true},
          callouts: {type: 'JSON', stringify: false, nullable: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        // more methods go here;

        CommentDomain.get = id =>
          FirebaseUtil.firebaseRef([
            COLLECTION,
            id,
          ].join('/'))
            .once('value')
            .then(ss => ss.val());

        CommentDomain.bindCountMetric = (scope, name, commentable) =>
          $firebaseObject(FirebaseUtil.firebaseRef([
            commentable.$class.COLLECTION + '-metrics',
            commentable.$id,
            'commentCount'
          ].join('/'))).$bindTo(scope, name);

        CommentDomain.getCountMetric = commentable =>
          isObject(commentable) && commentable.$class
          ? FirebaseUtil.read([
              commentable.$class.COLLECTION + '-metrics',
              commentable.$id,
              'commentCount'
            ].join('/'))
          : Promise.reject('required a commentable');

        CommentDomain.prototype.toString = function () {
          return this.message;
        };

        return CommentDomain;
      }]
  };
};



// WEBPACK FOOTER //
// ./src/js/comments/domain/CommentDomain.js